export default "__VITE_ASSET__7be28bf1__"